import { POST } from "../service/axiosMethods";
import html2canvas from "html2canvas";

const captureScreenshot = async () => {
    const canvas = await html2canvas(document.body);
    const base64Image = canvas.toDataURL("image/png");
    return base64Image;
};

export const sendMail = async (sharedWith, sharedBy, isWorkbook, sheetDetails, isTemplateWb = false) => {
    try {
        const formatted = new Date().toLocaleString('en-US', {
            weekday: 'short',
            month: 'short',
            day: 'numeric',
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            hour12: true,
            timeZoneName: 'short'
        }).replace(',', '').replace(/, (\w+)$/, ' ($1)').replace(' ', ' at ');
        const base64Image = await captureScreenshot();
        const sendMailToUser = await POST('/elasticsearch/mail/shareaccessmail', { sharedBy, sharedWith, isWorkbook, date: formatted, sheetDetails, isTemplateWb, image:base64Image })
    } catch (error) {
        console.error("Error in sendMail Mailhelper.js", error);

    }
}
